<template>
  <ConfirmationDialog :value="value" :loading="getRecoverFromDead01UddLoading" @confirmed="submit" @close="cancel">
    <template #title>Recover from Dead 01 UDD</template>

    <template #text>
      <div>Are you sure you want to recover this account from "Dead 01 UDD"?</div>
      <div>This will move all products in the "Dead 01 UDD" status to the "Live" status.</div>        
    </template>
  </ConfirmationDialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  
  import ConfirmationDialog from '@/components/Globals/ConfirmationDialog';

  export default {
    components: { ConfirmationDialog },

    props: {
      value: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        accountId: this.$route.params.id,
      }
    },

    computed: {
      ...mapGetters('creditControl', ['getRecoverFromDead01UddLoading', 'getRecoverFromDead01UddError']),
    },

    methods: {
      ...mapActions('creditControl', ['recoverFromDead01Udd', 'fetchCreditControl']),

      async submit() {
        await this.recoverFromDead01Udd(this.accountId);

        if (!this.getRecoverFromDead01UddError) {
          this.fetchCreditControl(this.accountId);
          this.cancel();
        }
      },

      cancel() {
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>